module.exports = __webpack_public_path__ + "img/03_slip_felt_technics1.23378052.png";